import { COLORS } from '@/constants';

type MapIconProps = {
  width?: number;
  height?: number;
} & React.SVGProps<SVGSVGElement>;

export const MapIcon = ({
  width = 24,
  height = 24,
  ...rest
}: MapIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M15.3506 11.1631C17.6634 11.1631 19.5381 13.0377 19.5381 15.3506C19.5381 16.1774 19.2983 16.9484 18.8848 17.5977L20 18.7129L18.7129 20L17.5977 18.8848C16.9484 19.2983 16.1774 19.5381 15.3506 19.5381C13.0377 19.538 11.1631 17.6634 11.1631 15.3506C11.1631 13.0377 13.0377 11.1632 15.3506 11.1631ZM15.3506 12.9834C14.0434 12.9835 12.9834 14.0434 12.9834 15.3506C12.9834 16.6578 14.0434 17.7177 15.3506 17.7178C16.6578 17.7178 17.7178 16.6578 17.7178 15.3506C17.7178 14.0433 16.6578 12.9834 15.3506 12.9834ZM5.58105 15.6221L0.917969 17.1738C0.705448 17.2446 0.471797 17.209 0.290039 17.0781C0.108206 16.947 0 16.7359 0 16.5117V3.33105C0.000145143 3.06948 0.147087 2.83027 0.379883 2.71094L5.58105 0.0439453V15.6221ZM12.0928 2.19531V10.8154C10.6843 11.8289 9.76758 13.4829 9.76758 15.3506C9.76758 15.9287 9.85545 16.4863 10.0186 17.0107L6.97656 15.7051V0L12.0928 2.19531ZM19.3018 2.55664C19.6869 2.55664 19.9998 2.86877 20 3.25391V12.2588C18.9994 10.7572 17.2903 9.76771 15.3506 9.76758C14.6976 9.76758 14.0706 9.87993 13.4883 10.0859V2.55664H19.3018Z"
      fill={COLORS['primary/900']}
    />
  </svg>
);